export default "__VITE_ASSET__8f849d3e__"